const setValue = (obj, keys, value) => {
    let current = obj;
    keys.forEach((key, i) => {
        if (i === keys.length - 1) {
            current[key] = value;
        }
        else {
            if (!current[key]) {
                current[key] = isNaN(keys[i + 1]) ? {} : [];
            }
            current = current[key];
        }
    });
};
export default function parseFields(fields) {
    const results = {};
    for (const [field, value] of Object.entries(fields)) {
        const keys = field.match(/[^\[\]]+/g);
        setValue(results, keys, value);
    }
    return results;
}
